import { signal } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { takeWhileAlive } from '@core/frontend-shared';
import { extendsConstructor } from '@core/shared/utils';
import { filter, map } from 'rxjs';
import { CrudManagerService } from '../crud-manager.service';
import { CrudManager2Component } from '../crud-manager2.component';
import * as i0 from "@angular/core";
import * as i1 from "../crud-manager.service";
import * as i2 from "@angular/router";
export let CrudManagerLayoutBase = /*#__PURE__*/(() => {
  class CrudManagerLayoutBase {
    // config:TConfig
    get config() {
      return this.crudManager.config.layout;
    }
    constructor(crudManager, route, router) {
      this.crudManager = crudManager;
      this.route = route;
      this.router = router;
      this.childRouteActive$ = this.crudManager.crudRouteState$.pipe(takeWhileAlive(), map(state => {
        return state.type !== 'list';
      }));
      this.editorActive = signal(false, ...(ngDevMode ? [{
        debugName: "editorActive"
      }] : /* istanbul ignore next */[]));
      this.router.events.pipe(takeWhileAlive(), filter(e => e instanceof RoutesRecognized)).subscribe(e => {
        this.reactToNewRouteSnapshot(e.state.root);
      });
      this.reactToNewRouteSnapshot(this.route.snapshot);
    }
    // to animate root route ViewChildren in/out when navigating to child editor routes,
    // we need to detect BEGINNING of navigation to a child CRUD route.
    reactToNewRouteSnapshot(snapshot) {
      let childRoute = snapshot;
      while (childRoute.firstChild) {
        childRoute = childRoute.firstChild;
      }
      const isCrudManagerBaseRoute = extendsConstructor(childRoute.component, CrudManager2Component);
      this.editorActive.set(!isCrudManagerBaseRoute);
    }
    static {
      this.ɵfac = function CrudManagerLayoutBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudManagerLayoutBase)(i0.ɵɵdirectiveInject(i1.CrudManagerService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Router));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: CrudManagerLayoutBase,
        inputs: {
          componentDisplay: "componentDisplay",
          infoMessage: "infoMessage"
        }
      });
    }
  }
  return CrudManagerLayoutBase;
})();